import { render, staticRenderFns } from "./wareHousesCard.vue?vue&type=template&id=39522b9c&"
import script from "./wareHousesCard.vue?vue&type=script&lang=js&"
export * from "./wareHousesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports